import { getSessionFlag, setSessionFlag } from "../utils/utils.js";

const announcementBarKey = "announcement-bar-dismissed";

const el = document.getElementById("announcement-bar-island");
if (!el) throw new Error("announcement-bar-island not found");

if (getSessionFlag(announcementBarKey)) {
  el.hidden = true;
  document.documentElement.removeAttribute("data-notice");
} else {
  const items = Array.from(el.querySelectorAll("[data-announcement-item]"));
  const dismissBtn = el.querySelector("[data-announcement-dismiss]");

  let current = 0;
  let intervalId = null;

  const show = (index) => {
    items[current].removeAttribute("data-visible");
    current = index;
    items[current].setAttribute("data-visible", "");
  };

  const start = () => {
    if (items.length <= 1) return;
    intervalId = setInterval(() => show((current + 1) % items.length), 5000);
  };

  const stop = () => clearInterval(intervalId);

  el.addEventListener("mouseenter", stop);
  el.addEventListener("mouseleave", start);

  dismissBtn?.addEventListener("click", () => {
    setSessionFlag(announcementBarKey);
    el.hidden = true;
    document.documentElement.removeAttribute("data-notice");
  });

  start();
}


